import { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

import treams from 'packages/kakapo-ui-kit/themes/treams';
import GlobalStyle from 'packages/kakapo-ui-kit/components/GlobalStyle';
import * as graphql from 'generated/graphql';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';

interface IProps {
	children: ReactNode;
}

export const replaceColorsInTheme = (theme: graphql.WorkspaceTheme, defaultColors = treams) => {
	const updatedColors: Record<string, string> = {
		primary: theme.primaryColor ?? defaultColors.colors.primary,
		primaryDark: theme.primaryColorDark ?? defaultColors.colors.primaryDark,
		secondary: theme.secondaryColor ?? defaultColors.colors.secondary,
	};

	const isGradientFilled = theme.linearGradientStart && theme.linearGradientEnd;

	const updatedImages: Record<string, string> = {
		lineGradient: isGradientFilled
			? `linear-gradient(90deg, ${theme.linearGradientStart} 0%, ${theme.linearGradientEnd} 100%)`
			: defaultColors.images.lineGradient,
		logo: theme.logo != null ? theme.logo.source.url : treams.images.logo,
		loginBackground:
			theme.background != null ? theme.background.source.url : treams.images.loginBackground,
	};

	return {
		colors: { ...defaultColors.colors, ...updatedColors },
		images: { ...defaultColors.images, ...updatedImages },
	} as any;
};

export default function BareLayout({ children }: IProps) {
	const workspace = useWorkspace();
	const { data: themeData } = graphql.useWorkspaceThemeQuery({
		variables: { id: workspace.id },
	});
	const theme = themeData
		? replaceColorsInTheme(themeData.workspace.theme as graphql.WorkspaceTheme)
		: treams;

	return (
		<ThemeProvider theme={theme}>
			<GlobalStyle />
			{children}
		</ThemeProvider>
	);
}
